export enum DisciplineRole {
	LegalResearcher = 50,
	HeadofLegalResearcher = 51,
	CourtClerk = 52,
	DecisionPrepartionClerk = 53,
	CommitteeMember = 54,
	CommitteeChairman = 55,
}
